// extracted by mini-css-extract-plugin
export default {"landingPageWrapper":"SignInLanding_landingPageWrapper__PX1t2","ButtonWrapper":"SignInLanding_ButtonWrapper__5x4Av"};